var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDPtaskIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33347 2V4H2.33347V2H4.33347ZM1.00013 0.666668V5.33333H5.66681V0.666668H1.00013ZM7.66681 0.666668H13.0001V2H7.66681V0.666668ZM7.66681 5.33333H13.0001V6.66667H7.66681V5.33333ZM7.66681 10H13.0001V11.3333H7.66681V10ZM6.13821 8.80474L5.19539 7.86193L3.00013 10.0572L1.80487 8.86193L0.862061 9.80474L3.00013 11.9428L6.13821 8.80474Z",
    fill: "#111822"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDPtaskIcon);
export default __webpack_public_path__ + "static/media/DPtaskIcon.439a5af4.svg";
export { ForwardRef as ReactComponent };